export default __webpack_public_path__ + "static/media/tablet-about-light.02005435.jpg";